export default process.env.NODE_ENV === "production"
  ? "pk_live_wCl7ZKthAsM1n4MIuxCByhlm00EnmHUC3c"
  : "pk_test_8YjEtguOhckk1fSxhgeN87xB003bvmYK2G";
